<template>
  <div class="element-radio">
     <RadioGroup v-model="currentValue"  v-if="!readonly" @on-change="change">
       <Radio :label="item.label" v-for="(item,index) in options" :key="index">{{ item.value }}</Radio>
    </RadioGroup>
    <label v-else>{{ currentValue }}</label>
  </div>
</template>

<script>
export default {
  name: 'elementRadio',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  data () {
    return {
      currentValue: ''
    }
  },
  created () {
    this.currentValue = this.value;
  },
  watch: {
    value (val) {
      this.currentValue = val;
    }
  },
  methods: {
    change () {
      this.$emit('input', this.currentValue)
    }
  }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/radio.vue